import React, { useRef, useState, useEffect } from 'react'
import { TextField, Box } from '@mui/material'

const OTPInput = ({ matches, onSubmit }) => {
  const [otp, setOtp] = useState(['', '', '', '']) // State to store OTP digits
  const inputRefs = useRef([]) // Refs for each text field

  // Handle change in OTP text fields
  const handleChange = (index, value) => {
    // Allow only digits and ensure only one character is entered
    if (/^\d$/.test(value) || value === '') {
      const newOtp = [...otp]
      newOtp[index] = value
      setOtp(newOtp)

      // Auto-focus to the next field if a digit is entered
      if (value !== '' && index < 3 && inputRefs.current[index + 1]) {
        inputRefs.current[index + 1].focus()
      }
    }
  }

  // Handle key down events for Backspace, Arrow keys, and other keys
  const handleKeyDown = (index, event) => {
    if (event.key === 'Backspace' && otp[index] === '' && index > 0) {
      inputRefs.current[index - 1].focus()
    }

    // Handle ArrowRight key
    if (event.key === 'ArrowRight' && index < otp.length - 1) {
      inputRefs.current[index + 1].focus()
    }

    // Handle ArrowLeft key
    if (event.key === 'ArrowLeft' && index > 0) {
      inputRefs.current[index - 1].focus()
    }
  }

  // Call onSubmit with OTP string whenever OTP changes
  useEffect(() => {
    if (otp.every(digit => digit !== '')) {
      onSubmit(otp.join(''))
    }
  }, [otp, onSubmit])

  return (
    <Box
      display='flex'
      justifyContent={matches ? 'flex-start' : 'start'}
      gap={1.4}
    >
      {otp.map((digit, index) => (
        <TextField
          key={index}
          inputRef={ref => (inputRefs.current[index] = ref)} // Assign ref to each text field
          value={digit}
          onChange={e => handleChange(index, e.target.value)}
          onKeyDown={e => handleKeyDown(index, e)}
          inputProps={{
            maxLength: 1, // Allow only one character
            style: { textAlign: 'center' } // Center align the text
          }}
          variant='outlined'
          sx={{
            // Fixed width for each text field
            '& input': {
              fontSize: '1.5rem', // Larger font size for better
              width: '50px',
              padding: '12px 4px',
              height: '32px'
            }
          }}
        />
      ))}
    </Box>
  )
}

export default OTPInput
